<template>
  <div class="specs">
    <div v-if="items.length > 0">
      <div class="spec-list">
        <spec
          v-for="(item, index) in items"
          :key="index"
          v-bind:useType="useType"
          v-bind:item="item"
        />
      </div>
    </div>
    <div v-else>ただいま商品を準備中です。</div>
  </div>
</template>

<script>
import Spec from '@/components/modules/products/Spec'

export default {
  props: ['useType', 'items'],
  components: {
    Spec,
  },
}
</script>

<style scoped>
.specs {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
}

.spec-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Specs.vue